import React from 'react';
import './ConfirmationLogin.scss';
import { Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import InputField from 'Components/Shared/InputField/InputField';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  isLoggedIn: boolean;
  isPasswordUser: boolean;
  currentInput: string;
  onPasswordChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onPasswordSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const ConfirmationLogin: React.SFC<IProps> = ({
  isLoggedIn,
  isPasswordUser,
  currentInput,
  onPasswordChange,
  onPasswordSubmit,
}) => {

  if (isLoggedIn) {
    return (
      <div className='confirmation-login'>
        <FormattedText 
          style='title'
          displayName='Dina bokningar och all information på ett ställe!'
          formattedName='order.confirmation.login.header'
        />
        <FormattedText 
          style='sub-title medium-bold'
          displayName='Dina bokningar sparas här på juliusbiljettservice.se'
          formattedName='order.confirmation.login.account.header'
        />
        <FormattedText
          displayName='Tack för ditt köp och välkommen tillbaka!'
          formattedName='order.confirmation.login.account.text'
        />
      </div>
    );
  }

  if (isPasswordUser && !isLoggedIn) {
    return (
      <div className='confirmation-login'>
        <FormattedText 
          style='title'
          displayName='Tack för ditt köp och välkommen tillbaka!'
          formattedName='order.confirmation.login.account.text'  
        />
      </div>
    );
  }

  return (
    <div className='confirmation-login'>
      <FormattedText 
        style='title'
        displayName='Dina bokningar och all information på ett ställe!'
        formattedName='order.confirmation.login.header'
      />
      <FormattedText 
        style='sub-title medium-bold'
        displayName='Spara dina bokningar här på juliusbiljettservice.se'
        formattedName='order.confirmation.login.create.header'
      />
      <FormattedText
        displayName='Ange ett lösenord så hittar du alltid dina bokningar. Lite tryggare och självklart gratis.'
        formattedName='order.confirmation.login.create.subheader'
      />
      <br />
      <form onSubmit={ onPasswordSubmit }>
        <InputField 
          type='password' 
          name='password' 
          label={ {
            displayName: 'Lösenord',
            formattedName: 'global.password',
          } }
          value={ currentInput }
          required={ true }
          minLength={ 6 }
          onChange={ onPasswordChange }
        />
        <Button type='submit'>
          <Icon type='plus' />
          <FormattedText
            displayName='Lägg till'
            formattedName='global.add'
          />
        </Button>
      </form>
    </div>
  );
};

export default ConfirmationLogin;


// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage/ConfirmationLogin/ConfirmationLogin.tsx